// Sidebar là REGISTRY theo section (Phụ lục E, SIDEBAR): phase sau thêm mục vào đúng section đã định, không tự tạo
// section mới. Section không có mục hiển thị thì ẩn. P0: home · projects · organization · settings.
import { PanelsTopLeft, Building2, MessageSquare, FolderKanban, House, Settings, Users, type LucideIcon } from "lucide-react";

export type SectionId = "home" | "work" | "projects" | "knowledge" | "organization" | "settings";

export interface NavItem {
  readonly id: string;
  readonly section: SectionId;
  readonly labelKey: string;
  readonly to: (ws: string) => string;
  readonly icon: LucideIcon;
  readonly visible?: (ctx: { role: string }) => boolean;
}

export const SECTIONS: readonly { id: SectionId; labelKey: string | null }[] = [
  { id: "home", labelKey: null },
  { id: "work", labelKey: "nav.sections.work" },
  { id: "projects", labelKey: "nav.sections.projects" },
  { id: "knowledge", labelKey: "nav.sections.knowledge" },
  { id: "organization", labelKey: "nav.sections.organization" },
  { id: "settings", labelKey: null },
];

export const NAV_ITEMS: readonly NavItem[] = [
  { id: "home", section: "home", labelKey: "nav.home", to: (ws) => `/w/${ws}/overview`, icon: House },
  { id: "work", section: "work", labelKey: "work.nav", to: (ws) => `/w/${ws}/work`, icon: MessageSquare },
  { id: "surfaces", section: "work", labelKey: "surfaces.list.title", to: (ws) => `/w/${ws}/surfaces`, icon: PanelsTopLeft },
  { id: "projects", section: "projects", labelKey: "nav.allProjects", to: (ws) => `/w/${ws}/projects`, icon: FolderKanban },
  { id: "members", section: "organization", labelKey: "nav.members", to: (ws) => `/w/${ws}/team`, icon: Users },
  { id: "org-units", section: "organization", labelKey: "nav.orgUnits", to: (ws) => `/w/${ws}/org-units`, icon: Building2 },
  { id: "settings", section: "settings", labelKey: "nav.settings", to: (ws) => `/w/${ws}/settings`, icon: Settings },
];

export function visibleSections(role: string) {
  return SECTIONS.map((s) => ({ ...s, items: NAV_ITEMS.filter((i) => i.section === s.id && (i.visible?.({ role }) ?? true)) })).filter((s) => s.items.length > 0);
}
